import { bgStyles } from "../utils/cssStyles";
import { Divider, Stack, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";

import React, { useState, useEffect, useLayoutEffect } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function LoginPage({ previousUrl}) {
  // console.log("previous url: ", previousUrl);
  const [formHndler, setFormHandler] = useState({ password: "", username: "" });
  const [records, setRecords] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [loder, setLoder] = useState(false);
  const [searchParams] = useSearchParams();
  const queryUsername = searchParams.get("username");
  const queryPassword = searchParams.get("password");
  

  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));


  let URL = window.location.href;
  var match = URL?.match(/companyid=([A-Za-z0-9]+)/);
  useLayoutEffect(() => {
    if (match) {
      var companyId = match[1];
      setLoder(true);
      axios
        .post(`/meonsupport/login_sso?companyid=${companyId}`)
        .then((res) => {
          if (
            res["data"]["apicall"] === "success" &&
            res["data"]["msg"] === "Active"
          ) {
            setErrMsg("");
            sessionStorage.setItem("token", res["data"]["apicall"]);
            window.location.replace("/");
          }
        })
        .catch((error) => {
          setLoder(false);
          setErrMsg("Somthing Went Wrong!");
        });
    }
  }, []);

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormHandler({ ...formHndler, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formHndler.username && formHndler.password) {
      setRecords({ ...formHndler });
      setFormHandler({ password: "", username: "" });
    }
  };


  useEffect(() => {
    if (records.username && records.password) {
      setLoder(true);
      axios
        .post("/meonsupport/login", records)
        .then((response) => {
          if (
            response["data"]["apicall"] === "success" &&
            response["data"]["msg"] === "Active"
          ) {
            setErrMsg("");
            sessionStorage.setItem("token", response["data"]["apicall"]);
            // window.location.replace("/");
            navigate(previousUrl || "/");
          } else if (
            response["data"]["apicall"] === "success" &&
            response["data"]["msg"] !== "Active"
          ) {
            setErrMsg(response["data"]["msg"]);
            setLoder(false);
          } else {
            setLoder(false);
            setErrMsg(response["data"]["apicall"]);
          }
        })
        .catch((error) => {
          setLoder(false);
          setErrMsg(error.response["data"]["apicall"]);
        });
    }
  }, [records]);

  const navigate = useNavigate();

  useEffect(() => {
    if (queryUsername && queryPassword) {
      setLoder(true);
      // console.log("queryUsername: ", queryUsername);
      // console.log("queryPassword: ", queryPassword);
      // setLoder(true);
      axios
          .post("/meonsupport/login", { username: queryUsername, password: queryPassword })
          .then((response) => {
          if (
            response["data"]["apicall"] === "success" &&
            response["data"]["msg"] === "Active"
          ) {
            setErrMsg("");
            sessionStorage.setItem("token", response["data"]["apicall"]);
            window.location.replace("/");
          } else if (
            response["data"]["apicall"] === "success" &&
            response["data"]["msg"] !== "Active"
          ) {
            setErrMsg(response["data"]["msg"]);
            setLoder(false);
          } else {
            setLoder(false);
            setErrMsg(response["data"]["apicall"]);
          }
        })
        .catch((error) => {
          // setLoder(false);
          setErrMsg(error.response["data"]["apicall"]);
        });
    }
  }, [queryUsername, queryPassword]);

  return (
    <>
      <Helmet>
        <title> Login | Support Tool </title>
      </Helmet>
      {loder ? (
        <div style={bgStyles}></div>
      ) : (
        <StyledContent>
          <div className='login_page'>
            <div className='login_div'>
              <div className='logo'>
                <figure>
                  <img src='/assets/images/meon-logo.png' alt='' width={250} />
                </figure>
              </div>
              <form autoComplete='off' method='post' onSubmit={handleSubmit}>
                <div className='login'>
                  <div className='user-input'>
                    <input
                      autoComplete='off'
                      type='email'
                      required
                      placeholder='Whats Your User Email ?'
                      name='username'
                      id='username'
                      value={formHndler.username}
                      onChange={handleInput}
                    />
                  </div>
                  <div className='password-input'>
                    <input
                      autoComplete='off'
                      type='password'
                      required
                      name='password'
                      id='password'
                      placeholder='Password'
                      value={formHndler.password}
                      onChange={handleInput}
                    />
                  </div>
                  <div className='form-group'>
                    <div id='log_err_msg' className='error_msg'>
                      <p style={{ fontSize: "small", color: "red" }}>
                        {errMsg}
                      </p>
                    </div>
                  </div>
                  <div className='signin-button'>
                    <Button type='submit' variant='contained'>
                      Sign In
                    </Button>
                  </div>
                </div>
              </form>
              <Divider sx={{ my: 5 }}>Follow Us On</Divider>
              <Stack
                spacing={5}
                direction={"row"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <div>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://www.facebook.com/meon.co.in/'
                  >
                    <img src='assets/images/facbook.png' alt='' />
                  </a>
                </div>
                <div>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://twitter.com/MeonTechnologi2'
                  >
                    <img src='assets/images/tweeter.png' alt='' />
                  </a>
                </div>
                <div>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://www.instagram.com/meontechnologies/'
                  >
                    <img src='assets/images/instagram.png' alt='' />
                  </a>
                </div>

                <div>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href='https://www.linkedin.com/company/meon-ai/mycompany/'
                  >
                    <img src='assets/images/linkdin.png' alt='' />
                  </a>
                </div>
              </Stack>
            </div>
            <div className='image_div'>
              <div className='headline'>
                <h1>Meon Support Tool</h1>
                <p>
                  You can expect creative designs, professional
                  approach,experienced team and fast delivery at every point.
                </p>
              </div>
            </div>
          </div>
          <Box
            sx={{
              padding: "3px 0",
              position: "fixed",
              right: 5,
              bottom: 0,
              display: "flex",
              justifyContent: isBelow768 ? "center" : "flex-end",
              alignItems: "center",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <a
              style={{ textDecoration: "none" }}
              href='https://meon.co.in/'
              rel='noreferrer'
              target='_blank'
            >
              {" "}
              <img src='/meon.png' width={95} alt='im' />
            </a>{" "}
          </Box>
        </StyledContent>
      )}
    </>
  );
}

const StyledContent = styled("div")`
  .logo {
    width: 100%;
    margin-bottom: 50px;
    text-align: center;
    margin-top: 21px;
  }
  .login_page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 97vh;
    width: 100%;
  }
  .login_div {
    width: 100%;
  }
  .login_div form {
    text-align: center;
  }
  .login_div input {
    width: 55%;
    padding: 16px;
    margin: 10px 0;
    border-radius: 10px;
    border: 2px solid #f0f0f0;
    background-color: #dbdada;
  }
  .login_div input:hover {
    border: 2px solid #185cb7;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  .signin-button button {
    font-weight: 600;
    width: 59%;
    padding: 11px 0;
    border-radius: 10px;
  }
  .signin-button input:hover {
    border: 2px solid #4f81c2;
  }
  .signin-button {
    margin-top: 30px;
    width: 100%;
  }

  .image_div {
    background-image: url(assets/images/back_img.png);
    background-repeat: no-repeat;
    background-size: cover;
    width: 90%;
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 40px;
    border-radius: 5px;
  }

  .headline {
    background-color: #185cb7;
    height: 90vh;
    width: 100%;
    border-radius: 5px;
    opacity: 0.8;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .headline p {
    margin: 8px 70px;
    text-align: center;
  }
  .image_div img {
    width: 60%;
  }
  @media only screen and (max-width: 768px) {
    .login_page {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100%;
      flex-wrap: wrap;
    }
    .login_div {
      height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: center;
      /* align-items: center; */
    }
    .image_div {
      display: none;
    }
    .social-icon {
      margin: 0 70px;
    }
  }
`;